import { Component } from '@angular/core';
import { RelatorioApresentacaoComponent } from '../relatorio-apresentacao/relatorio-apresentacao.component';

@Component({
  selector: 'app-planejamento-orcamentario-apresentacao-wrapper',
  standalone: true,
  imports: [RelatorioApresentacaoComponent],
  template: `
    <app-relatorio-apresentacao
      [breadcrumb]="'Módulo de Orçamento para garantia de um padrão de qualidade'"
      [breadcrumbColor]="'#7FA6BF'"
      [iconeHero]="'assets/ilustrations/papers-outline.svg'"
      [subtituloHero]="'Módulo'"
      [corSubtituloHero]="'#6091AF'"
      [tituloHero]="'Orçamento para garantia de um padrão de qualidade'"
      [corTituloHero]="'#6091AF'"
      [descricaoHero]="'Este módulo calcula o orçamento necessário para financiar a educação em uma localidade específica.'"
      [textoBotaoHero]="'Acessar simulação'"
      [corBotaoHero]="'transparent'"
      [corTextoBotaoHero]="'#6091AF'"
      [linkBotaoHero]="'/selecionar-local'"
      [imagemHero]="'assets/imagens/children-writing.png'"
      [backgroundHero]="'assets/ilustrations/circles-background-1.png'"
      [infoIcone]="infoIcons"
      [infoTexto]="infoTexts"
      [tituloCta]="'Que tal simular o planejamento orçamentário para o seu município?'"
      [textoBotaoCta]="'Comece a usar'"
      [corBotaoCta]="'#6091AF'"
      [corTextoBotaoCta]="'#fff'"
      [linkBotaoCta]="'/selecionar-local'"
      [corSetaHero]="'#6091AF'"
      [corSetaCta]="'#fff'"
    ></app-relatorio-apresentacao>
  `
})
export class PlanejamentoOrcamentarioApresentacaoWrapperComponent {
  infoIcons = [
    { img: 'assets/ilustrations/brasil-map-outline.svg', text: 'Brasil (plano nacional)', color: '#6091AF' },
    { img: 'assets/ilustrations/acre-map-outline.svg', text: 'Estado (plano estadual ou rede estadual)', color: '#6091AF' },
    { img: 'assets/ilustrations/house-structure-1.svg', text: 'Município (plano municipal ou rede municipal)', color: '#6091AF' }
  ];
  infoTexts = [
    { html: 'Por meio desse módulo o SimCAQ busca auxiliar a elaboração de orçamentos para a educação básica no nível municipal, estadual e nacional a partir de parâmetros de condições de qualidade, permitindo a construção de cenários para um novo modelo de financiamento baseado nas reais demandas de insumos das escolas e das redes públicas de ensino necessários para a oferta de uma educação em condições de qualidade. O orçamento necessário é calculado a partir de padrões mínimos de qualidade, apresentados no documento <a href="/pqr" class="text-orange-400" style="text-decoration: underline; cursor: pointer;">Padrão de Qualidade de Referência (PQR)</a>.', color: '#444' },
    { html: 'Referência (PQR), tendo como pressuposto a defesa de que todos os estudantes são sujeitos de direitos e que precisam ter garantidas condições igualitárias que respeitem e possibilitem seu desenvolvimento integral. No entanto, diante da grande diversidade de realidades e contextos educacionais no Brasil, os usuários podem alterar esses parâmetros para elaborar planos estaduais e municipais de educação específicos para a localidade e simular diferentes cenários de financiamento.', color: '#444' }
  ];
}
